import type { ReactNode } from "react";
import { MdDelete } from "react-icons/md";
import { useLanguage } from "context/LanguageContext";

interface BulkSelectBarProps {
  selectedCount: number;
  onClear: () => void;
  onDelete?: () => void;
  deleteLabel?: string;
  clearLabel?: string;
  selectedLabel?: (count: number) => string;
  extraActions?: ReactNode;
  className?: string;
}

const BulkSelectBar = ({
  selectedCount,
  onClear,
  onDelete,
  deleteLabel,
  clearLabel,
  selectedLabel,
  extraActions,
  className = "",
}: BulkSelectBarProps): JSX.Element => {
  const { t } = useLanguage();
  return (
    <div
      className={`mb-4 flex items-center justify-between gap-3 rounded-2xl border border-brand-200 bg-brand-50 px-4 py-3 dark:border-brand-500/30 dark:bg-brand-500/10 ${className}`.trim()}
    >
      <p className="text-sm font-semibold text-brand-700 dark:text-brand-200">
        {selectedLabel
          ? selectedLabel(selectedCount)
          : t("bulkSelect.selectedCount", { count: selectedCount })}
      </p>
      <div className="flex items-center gap-2">
        {extraActions}
        <button
          type="button"
          onClick={onClear}
          className="rounded-xl border border-line bg-surface px-3.5 py-2 text-xs font-semibold text-gray-600 hover:bg-surface-hover dark:text-gray-300"
        >
          {clearLabel ?? t("bulkSelect.clear")}
        </button>
        {onDelete ? (
          <button
            type="button"
            onClick={onDelete}
            className="inline-flex items-center gap-1.5 rounded-xl bg-danger-600 px-3.5 py-2 text-xs font-semibold text-white hover:bg-danger-700"
          >
            <MdDelete className="h-3.5 w-3.5" />
            {deleteLabel ?? t("bulkSelect.deleteSelected")}
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default BulkSelectBar;
